import { put, select, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import { fetchOpenApiInfo } from 'APIPackage/MainModule/services/openCredentialsApi';
import { IOpenApiInfo } from 'APIPackage/MainModule/interfaces/IOpenApiInfo';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { fetchPassportById, fetchPassportPdfById } from 'APIPackage/KnmSearchModule/services/knmSearchApi';
import { IKnmPreviewResponse } from 'APIPackage/KnmSearchModule/interfaces/IKnmPreviewResponse';
import { saveFile } from 'CorePackage/MainModule/common/saveFile';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';

import { knmPreviewInitPage, knmPreviewSetOpenApiInfo, knmPreviewSetPassportData } from '../actions/knmPreviewActions';
import { KnmPreviewActionsEnum } from '../enums/KnmPreviewActionsEnum';
import { getKnmPreviewOpenApiInfo, getKnmPreviewPassportData } from '../selectors/knmPreviewSelectors';

export function* watchKnmPreviewSaga() {
  yield takeEvery(KnmPreviewActionsEnum.KNM_PREVIEW_INIT_PAGE, knmPreviewInitPageSaga);
  yield takeEvery(KnmPreviewActionsEnum.KNM_PREVIEW_DOWNLOAD_PASSPORT_PDF, knmPreviewDownloadPassportPdfSaga);
}

function* knmPreviewInitPageSaga(action: ActionType<typeof knmPreviewInitPage>) {
  yield sagaWrapper({
    *funcTry() {
      const { id } = action.payload;

      yield knmPreviewGetOpenApi();
      if (id) {
        yield knmPreviewGetPassportData(id);
      }
    },
  });
}

function* knmPreviewGetOpenApi() {
  function* funcTry() {
    const res: string = yield fetchOpenApiInfo();
    const data: IOpenApiInfo = JSON.parse(res);

    yield put(knmPreviewSetOpenApiInfo(data));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* knmPreviewGetPassportData(id: string) {
  function* funcTry() {
    const openApiInfo: IOpenApiInfo | undefined = yield select(getKnmPreviewOpenApiInfo);

    if (openApiInfo && id) {
      const response: IKnmPreviewResponse = yield fetchPassportById(openApiInfo, id);

      yield put(knmPreviewSetPassportData(response?.list?.[0]));
    }
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* knmPreviewDownloadPassportPdfSaga() {
  function* funcTry() {
    const state: IRootState = yield select();
    const openApiInfo = getKnmPreviewOpenApiInfo(state);
    const passportData = getKnmPreviewPassportData(state);
    const id = passportData?.id;
    const isPm = passportData?.version === 'ERKNM' && passportData.pmErknm;

    if (openApiInfo && id) {
      const response: Blob = yield fetchPassportPdfById(openApiInfo, id.toString());
      const file = new Blob([response], { type: 'application/pdf' });

      saveFile(file, `${isPm ? 'pm' : 'knm'}-${passportData.erpId}.pdf`);
    }
  }

  yield sagaWrapper({
    funcTry,
  });
}
